__turbopack_context__.v({
  "blink": "columns-module-scss-module__X6h2hq__blink",
  "columns1": "columns-module-scss-module__X6h2hq__columns1",
  "columns2": "columns-module-scss-module__X6h2hq__columns2",
  "columns3": "columns-module-scss-module__X6h2hq__columns3",
  "columns4": "columns-module-scss-module__X6h2hq__columns4",
});
